<template>
  <div>
    <div :class="{ 'video-container': true, 'video-container--results': results, 'video-container--suppliers': pageMode === 'suppliers', 'video-container--managers': pageMode === 'managers' }">
      <template v-for="(video, index) in videos">
        <Video :file="video.file" :index="video.index" :key="index" :poster="video.poster" :fileMobile="video.fileMobile" :posterMobile="video.posterMobile" />
      </template>
      <div :class="['video-container__inner']" v-if="questions">
        <template v-for="(question, index) in questions">
          <Question :index="question.index" :question-id="question.id" :key="index" @resetRC="resetRC" @executeRC="executeRC" @getProducts="getProducts" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { assetPath } from './../mixins/assetPath.js'
import { pageMode } from './../mixins/pageMode.js'
import Question from './Question.vue'
import Video from './Video.vue'

export default {
  name: 'VideoContainer',
  components: {
    Question,
    Video
  },
  props: {
    msg: String
  },
  computed: {
    videos() {
      if (this.pageMode === 'suppliers') {
        return this.$store.getters.supplierVideos
      } else {
        return this.$store.getters.videos
      }
    },
    questions() {
      if (this.pageMode === 'suppliers') {
        return [] // no supplier questions
      } else {
        return this.$store.getters.questions
      }
    },
    imagesToPreload() {
      return this.$store.getters.imagesToPreload
    },
    results() {
      return this.$store.getters.currentId === 'results'
    }
  },
  mounted () {
    // this.startFirstVideo()
    this.preLoadImages()
  },
  methods: {
    // startFirstVideo() {
    //   this.$store.dispatch('startFirst')
    // },
    preLoadImages() {
      // TODO window.innerWidth detection for mobile stuff later?
      var image = []
      // console.log(this.imagesToPreload, this.assetPath)
      this.imagesToPreload.map((img, i) => {
        image[i] = new Image()
        // console.log(this.assetPath + img)
        image[i].src = this.assetPath + img
      })
    },
    resetRC() {
      this.$emit('resetRC')
    },
    executeRC() {
      this.$emit('executeRC')
    },
    getProducts(){
      this.$emit('getProducts')
    }
  },
  mixins: [assetPath, pageMode]
}
</script>

<style lang="scss">
  .video-container {
    position: relative;
    background-color: #ddd;
    /* padding-bottom: 109.333%; */
    aspect-ratio: 75/82;
    @media screen and (min-width: 769px) {
      /* padding-bottom: 46.562%; */
      aspect-ratio: 14/6.51868;
    }
  }
  .video-container--suppliers {
    aspect-ratio: 16/9;
    @media screen and (min-width: 769px) {
      aspect-ratio: 16/9;
    }
  }
  .video-container__inner {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .video-container--results {
    /* padding-bottom: 0; */
    aspect-ratio: 1/1.4;

    .video-container__inner {
      /* position: static; */
    }
    .question, .question__wrapper {
      /* position: static; */
      width: 100%;
    }
    @include breakpoint(large) {
      /* padding-bottom: 0; */
      aspect-ratio: 32/16;
    }
    @include breakpoint(xlarge) {
      /* padding-bottom: 0; */
      aspect-ratio: 32/10.3125;
    }
  }

</style>
